import React from 'react';
import ArticleCard from './ArticleCard';
import './allEvents.scss';
import '../pages/index.scss';
import { graphql, useStaticQuery } from 'gatsby';
import { StrapiEvents } from '../data/StrapiEvent';
import { formatISODateTime } from '../commons/utils';

interface Props {
  title: string;
  showMoreButton?: boolean;
  singleMonth?: string;
}

const AllEvents: React.FC<Props> = ({ showMoreButton, title }) => {
  const allEventsData: StrapiEvents = useStaticQuery(graphql`
    {
      allStrapiEvents {
        edges {
          node {
            id
            type
            name
            date
            eventUrl
            fields {
              slug
            }
            banner {
              childImageSharp {
                fluid(maxWidth: 500, maxHeight: 250) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
      allStrapiEventsPage {
        edges {
          node {
            allEventsCopyText
          }
        }
      }
    }
  `);

  return (
    <div className="allEventsContainer">
      <h2 className="alignCenter">{title}</h2>
      <div className="allEventsContainerInner">
        {allEventsData.allStrapiEvents.edges
          .map((edge) => edge.node)
          .sort(({ date: dateA }, { date: dateB }) => {
            // @ts-ignore
            return new Date(dateB) - new Date(dateA);
          })
          .map((event) => {
            return (
              <ArticleCard
                forEvents
                eventUrl={event.fields.slug}
                imgURL={event.banner.childImageSharp.fluid}
                key={event.id}
                title={event.date}
                body={event.name}
                date={event.date}
              />
            );
          })}
      </div>
      {showMoreButton && (
        <div className="allEventsContainerButtonContainer">
          <button className="buttonSecondaryTeal">Show More</button>
        </div>
      )}
    </div>
  );
};

export default AllEvents;
